import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * The read-only disclosure modal.
 *
 * Opening it does NOT accept, and pressing Done does not accept either. The only thing it
 * reports back is that it was opened, which is recorded against the acceptance but never gated
 * on — we do not track scrolling and must not imply that we do.
 *
 * Rendered from the same Markdown bytes the Signing Log appends, through the same restricted
 * subset, so the signer and the evidence document see the same text.
 */
@Component({
  selector: 'app-disclosure-modal',
  templateUrl: './disclosure-modal.component.html',
  styleUrls: ['./disclosure-modal.component.css'],
  standalone: false
})
export class DisclosureModalComponent {
  @Input() visible = false;
  @Input() title = '';
  /** Markdown body, exactly as stored. */
  @Input() body = '';
  /** True while the text is being fetched. */
  @Input() loading = false;

  @Output() closed = new EventEmitter<void>();

  close(): void {
    this.closed.emit();
  }
}
